import Associations from './Associations.page';

export default Associations;